 export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
     'React',
     "Bootstrap",
     "MongoDB",
     "nodejs",
     "materialui",
    "ExpressJS",
    "Redux",
    "chakra",
    "c"
]

